import Axios from 'axios';
import React, { useState } from 'react';
import ModalFinanciado from '../Modals/ModalFinanciado';

import InputOptions from '../../../utils/InputOptions';
import InputRange from '../../../utils/InputRange';
import { cleanRutFormat } from '../../../utils';
import useAccessoriesData from '../../hooks/useAccessoriesData';
import useApprovalHistoryData from '../../hooks/useApprovalHistoryData';
import useConfiguratorData from '../../hooks/useConfiguratorData';
import useDealershipsData from '../../hooks/useDealershipsData';
import useFinanciadoData from '../../hooks/useFinanciadoData';
import useLeadData from '../../hooks/useLeadData';
import usePersonalData from '../../hooks/usePersonalData';
import usePriceData from '../../hooks/usePriceData';

import { CurrencyFormat } from '../../../utils';
import CurrencyInput from '../CurrencyInput';

const r9Props = {
    r9: true,
    minDownpayment: 31,
    maxDownpayment: 40,
    minFees: 24,
    maxFees: 36
}

const PaymentOptions = () => {

    const { getIgnoreFinanciado, getFinanciado, setIgnoreFinanciado, setFinanciado, setPreApproved, setSimulationChanged, getSimulationChanged, getSimulateNumberFees, getSimulateDownpaymentPercentage, setSimulateDownpaymentPercentage, setSimulateNumberFees, setSimulatedCreditData, getPreApprovalData, getSimulatedCreditData } = useFinanciadoData();
    const { getSelectedVersion, getSelectedModel, getSelectedColor, getSelectedPrepaidMaintenancePlan } = useConfiguratorData();
    const { selectedDealership } = useDealershipsData();
    const { getPersonalData } = usePersonalData();
    const { updateLead } = useLeadData();
    const { setLastApprovalResponse, getLastApprovalResponse } = useApprovalHistoryData();
    const { getFinancedTotal } = usePriceData();
    const { getAddedAccessories, getAccessories, getTotalPriceAccesories } = useAccessoriesData();


    const simulationChanged = getSimulationChanged();
    const ignoreFinanciado = getIgnoreFinanciado();
    const financiado = getFinanciado();
    const model = getSelectedModel();
    const version = getSelectedVersion();
    const personalData = getPersonalData();
    const financedTotal = getFinancedTotal();
    const simulateNumberFees = getSimulateNumberFees();
    const simulateDownpaymentPercentage = getSimulateDownpaymentPercentage();
    const totalPriceAccessories = getTotalPriceAccesories();
    const selectedColor = getSelectedColor();
    const selectedPrepaidMaintenancePlan = getSelectedPrepaidMaintenancePlan();
    const simulatedCreditData = getSimulatedCreditData()

    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [formSent, setFormSent] = useState(false);
    const [isPreApproval, setIsPreApproval] = useState(false);
    const [checkedButton, setCheckedButton] = useState(false);
    const [isEvaluating, setIsEvaluating] = useState(false);
    const [formSalary, setFormSalary] = useState("");
    const [processing, setProcessing] = useState(false);
    const [defaultInputProps, setDefaultInputProps] = useState(r9Props);
    const [error, setError] = useState(null);
    const [simulateData, setSimulateData] = useState({
        vehicleAmount: getFinancedTotal(true),
        car_amount: getFinancedTotal(true),
        downpayment_percentage: parseFloat(simulateDownpaymentPercentage),
        number_fees: parseInt(simulateNumberFees),
        smart_buy: true,
        sap_code: version.sap_id ? version.sap_id : 0,
        option_code: version.option_code ? version.option_code : '',
    });

    const formValid = formSalary;

    const financiamientoEnabled = true;

    const cleanMask = (value) => {
        return value.replace('$', '')
            .replaceAll('.', '')
            .replaceAll('-', '')
            .replaceAll('_', '');
    }

    // const handleFormSubmit = (e) => {
    //     e.preventDefault();

    //     let submitData = {
    //         client_rut: personalData.rut,
    //         salary: parseInt(formSalary),
    //         client_mail: personalData.email,
    //         phone: personalData.phone_number,
    //         car_amount: financedTotal,
    //         downpayment: financiado.downpayment_amount,
    //         equivalent_annual_load: financiado.equivalent_annual_load,
    //         year: model.year,
    //         sap_code: financiado.sap_code,
    //         fees: financiado.number_fees,
    //         fee_amount: financiado.fee_value,
    //         guaranteed_future_value: financiado.future_value_guaranteed,
    //         smart_buy: financiado.smart_buy,
    //         region: selectedDealership.region,
    //         dealer_id: selectedDealership.id,
    //         dealer: selectedDealership.brand_name,
    //         branch: selectedDealership.name,
    //         text_maintenance: selectedPrepaidMaintenancePlan ? selectedPrepaidMaintenancePlan.name : null,
    //         amount_maintenance: selectedPrepaidMaintenancePlan ? parseFloat(selectedPrepaidMaintenancePlan.price) : 0,
    //         // selected_color_id: selectedColor.id,
    //         bonus_financing: 0 + parseFloat(getSelectedVersion().financing_bonus || 0) + parseFloat(getSelectedVersion().smart_buy_bonus || 0),

    //         first_name: personalData.first_name,
    //         last_name: personalData.last_name,
    //         rent_fee: getPreApprovalData().rent_fee,
    //         total_cost: getPreApprovalData().total_cost,
    //         plan_id: simulateData.smart_buy ? "14" : "159",
    //         rate: getPreApprovalData().rate,
    //         request_id: getPreApprovalData().request_id,
    //         option_code: version.option_code ? version.option_code : '',
    //         dealership_id: selectedDealership.rut ? selectedDealership.rut : '',
    //         rent_fee: formSalary,
    //         amount_maintenance: selectedPrepaidMaintenancePlan ? parseFloat(selectedPrepaidMaintenancePlan.price) : 0,
    //         text_maintenance: selectedPrepaidMaintenancePlan ? selectedPrepaidMaintenancePlan.name : null,
    //     }

    //     if (totalPriceAccessories) {
    //         submitData.amount_accesories = totalPriceAccessories;
    //         submitData.list_accesories = getAddedAccessories().length > 0 ? getAddedAccessories().map(accessory => `${accessory.name} (${accessory.price})`).join('/') : null;
    //     }

    //     let formData = {
    //         salary: formSalary,
    //     }

    //     setFinanciado(formData);
    //     setProcessing(true);
    //     Axios.post(`/api/vehicles/bnp/credit_pre_approval/`, submitData).then(response => {
    //         setFormSent(true);
    //         let data = { ...response.data };
    //         if (data.is_pre_approval) {
    //             setCheckedButton(true);
    //             setTimeout(() => {
    //                 setSimulationChanged(false);
    //                 setIsPreApproval(data.is_pre_approval);
    //                 setPreApproved(data.is_pre_approval);
    //             }, 1500)
    //         } else {
    //             setIsEvaluating(true);
    //             setSimulationChanged(false);
    //             setTimeout(() => {
    //                 setIsPreApproval(data.is_pre_approval);
    //                 setPreApproved(data.is_pre_approval);
    //                 setIsEvaluating(false);
    //             }, 3000)
    //         }
    //         const approval_response = {
    //             is_set: true,
    //             model: getSelectedModel().name,
    //             version: getSelectedVersion().name,
    //             downpayment_percentage: financiado.downpayment_percentage,
    //             number_fees: financiado.number_fees,
    //             salary: formData.salary,
    //             pre_approved_result: data.is_pre_approval
    //         };
    //         setLastApprovalResponse(approval_response);
    //         setProcessing(false);
    //         updateLead([
    //             { name: 'resultado-preaprobacion', value: data.is_pre_approval ? 'aprobado' : 'no aprobado' },
    //             { name: 'ingreso', value: formData.salary },
    //             { name: 'informacion_preaprobacion', value: `Modelo: ${approval_response.model}/Versión: ${approval_response.version}/%pie: ${approval_response.downpayment_percentage}/CantidadCuotas: ${approval_response.number_fees}/Ingreso: ${approval_response.salary}/Resultado: ${approval_response.pre_approved_result ? 'aceptado' : 'rechazado'}` },
    //         ]);
    //     })
    //         .catch((error) => {
    //             // console.error(error);
    //             setIsPreApproval(false);
    //             setPreApproved(false);
    //             setProcessing(false);
    //             updateLead([
    //                 { name: 'resultado-preaprobacion', value: 'no aprobado' },
    //                 { name: 'ingreso', value: formData.salary },
    //             ]);
    //         })
    // }

    const simulateCredit = (data) => {
        setLoading(true);
        const cleanRut = cleanRutFormat(getPersonalData().rut);
        Axios.post(`/api/vehicles/bnp/simulate_credit/`, {
            ...data,
            // v1:
            car_amount: getFinancedTotal(true),
            full_name: getPersonalData().full_name,
            email: getPersonalData().email,
            rut: cleanRut,
            phone_number: getPersonalData().phone_number,
            option_code: version.option_code ? version.option_code : '',
            dealership_id: selectedDealership.rut ? selectedDealership.rut : '',
            model_id: getSelectedModel().model_id,
            // v2:
            vehicleAmount: getFinancedTotal(true),
            first_name: getPersonalData().first_name,
            last_name: getPersonalData().last_name,
            email: getPersonalData().email,
            clientRut: cleanRut,
            phone: getPersonalData().phone_number,
            downPayment: Math.round((simulateDownpaymentPercentage / 100) * getFinancedTotal(true)),
            creditAmount: getFinancedTotal(true) - Math.round((simulateDownpaymentPercentage / 100) * getFinancedTotal(true)),

        }).then(response => {
            let data = { ...response.data };
            setSimulationChanged(true);
            setSimulateData(prevState => ({
                ...prevState,
                credit_total_cost: data.credit_total_cost || data.totalCost,
                downpayment_amount: data.downpayment_amount || data.downPayment,
                equivalent_annual_load: data.equivalent_annual_load || data.cae,
                future_value_guaranteed: data.future_value_guaranteed || data.vfg,
                fee_value: data.fee_value || data.repaymentAmount,
                rate_interest: data.rate_interest,
                simulation_id: data.simulationId,
                rate: data.rate,
            }))
            setSimulatedCreditData(data)
            getPreApprovalData().total_cost = data.totalCost;
            getPreApprovalData().request_id = data.simulationId;
            getPreApprovalData().rate = data.rate;
        })
            .catch((error) => {
                console.log(error);
                setError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleChangeDownpayment = value => {
        let data = {
            ...simulateData,
            downpayment_percentage: parseInt(value)
        }
        setSimulateDownpaymentPercentage(parseInt(value));
        setSimulateData(data);
        simulateCredit(data);
    }

    const handleChangeFees = value => {
        let data = {
            ...simulateData,
            number_fees: parseInt(value)
        }
        setSimulateNumberFees(parseInt(value));
        setSimulateData(data);
        simulateCredit(data);
    }

    const handlePaymentSimulation = () => {
        ignoreFinanciado.value ? setIsOpen(true) : ""
    }

    const handleEdit = () => {
        setIsOpen(true);
        setCheckedButton(false);
    }

    return (
        <div className="paymen-options" id="payment-options">
            <div className="component-header">
                <h2>Opciones de Compra</h2>
                <div className="component-subtitle">Selecciona la opción de compra que te interesa.</div>
            </div>

            {version && (version.financing_bonus || version.smart_buy_bonus) ? (
                <div className="bonus-container">
                    <div className="bonus-image">
                        <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/bonus.svg`} />
                    </div>
                    <div>
                        <p>
                            Si tu opción es financiada, cuentas con:
                        </p>
                        <ul>
                            {version.financing_bonus && <li>Bono <strong>financiamiento MAF</strong> de {CurrencyFormat(version.financing_bonus)}.</li>}
                            {version.smart_buy_bonus && <li>Bono <strong>financiamiento Plan Renueve</strong> de {CurrencyFormat(version.smart_buy_bonus)}.</li>}
                        </ul>
                    </div>
                </div>
            ) : null}

            <div className="component-body">
                {financiamientoEnabled ? (
                    <div className={"item-box mini-simulator " + (!ignoreFinanciado.value ? 'active' : '')}>
                        <span>Financiamiento MAF {!ignoreFinanciado.value ? <small onClick={() => handleEdit()}>Editar <i className="icon chevron-strong"></i></small> : ""}</span>
                        {ignoreFinanciado.value ? (
                            <>
                                <div className="inputs-container">
                                    <InputRange
                                        onChangeValue={handleChangeDownpayment}
                                        title="1. Porcentaje de Pie"
                                        subtitle={`Hasta un ${defaultInputProps.maxDownpayment}% del valor total del vehículo.`}
                                        valueText="% Mínimo"
                                        valueTextMax="% Máximo"
                                        suffix="%"
                                        defaultValue={simulateDownpaymentPercentage}
                                        minValue={defaultInputProps.minDownpayment}
                                        maxValue={defaultInputProps.maxDownpayment} />
                                    <InputOptions
                                        onChangeValue={handleChangeFees}
                                        title="2. Cantidad de Cuotas"
                                        subtitle="Seleccione en cuantas cuotas desea comprar su vehículo."
                                        defaultValue={simulateNumberFees}
                                        minValue={defaultInputProps.minFees}
                                        maxValue={defaultInputProps.maxFees} />
                                    <div className="input-range-container">
                                        <h2>3. Simula tu financiamiento</h2>
                                        <p>Haz click en "Iniciar" para simular y preaprobar tu financiamiento.</p>
                                    </div>
                                </div>
                                <div className="button-container">
                                    <a className="btn black" onClick={() => handlePaymentSimulation()}>Iniciar</a>
                                </div>
                            </>
                        ) : 
                            <div className="simulation-result">
                                <p className="title">{simulateNumberFees} cuotas de {CurrencyFormat(simulatedCreditData.repaymentAmount)}</p>
                                <p className='plus'>+ Valor del pie: {CurrencyFormat(simulatedCreditData.downPayment)}</p>
                                <p className='plus'>+ Cuota Final: {CurrencyFormat(simulatedCreditData.vfg)}</p>
                                {
                                    version.brand_bonus ?
                                    <p className="red">Incluye bono de marca {CurrencyFormat(version.brand_bonus)}</p>
                                    : null
                                }
                                {
                                    version.financing_bonus ?
                                    <p className="red">Incluye bono de financiamiento de {CurrencyFormat(version.financing_bonus)}</p>
                                    : null
                                }
                            </div>
                        }
                        {/* 
                        {!ignoreFinanciado.value &&
                            <div className="financiamiento-form">
                                {!formSent || simulationChanged ?
                                    <>
                                        <span>¿Quieres solicitar la preaprobación de tu financiamiento?</span>
                                        <p>Es simple, sólo necesitamos que nos indiques tu ingreso promedio líquido mensual. Al enviarnos estos datos lo podremos preaprobar y luego contactarte.</p>
                                        <form id="financiamiento-form" onSubmit={handleFormSubmit}>
                                            <div className="form-element">
                                                <CurrencyInput
                                                    className={`text ${parseInt(formSalary) < 600000 ? 'error' : ''}`}
                                                    name="ingreso"
                                                    placeholder="Ingreso líquido mensual"
                                                    onChange={(e) => setFormSalary(parseInt(cleanMask(e.target.value)))} disabled={processing} />
                                            </div>
                                            {!checkedButton ? (
                                                <div className="form-element">
                                                    <button className="btn outline-black small" type="submit" disabled={!formValid || processing || parseInt(formSalary) < 600000}>Solicitar preaprobación <img style={{ display: processing ? 'inline' : 'none' }} className="ajax-loader" src={`${window._env_.STATIC_HOST}/static/website/images/ajax-loader.gif`} /></button>
                                                </div>
                                            ) : (
                                                <div className="form-element tick-button">
                                                    <button className="btn outline-red small" ><img src={`${window._env_.STATIC_HOST}/static/website/images/icons/tick.svg`} /></button>
                                                </div>
                                            )}
                                        </form>
                                    </>
                                    :
                                    <div className={"approve " + (!isPreApproval && isEvaluating ? "evaluando" : "")}>
                                        {isPreApproval ?
                                            <div className="fees-details">
                                                <p>{financiado.number_fees} cuotas de {CurrencyFormat(financiado.fee_value)}</p>
                                                <ul>
                                                    <li>+ Valor del pie: {CurrencyFormat(financiado.downpayment_amount)}</li>
                                                    <li>+ Cuota Final: {CurrencyFormat(financiado.future_value_guaranteed)}</li>
                                                </ul>
                                                <div className="details-container">
                                                    {version.financing_bonus ?
                                                        <span className="bono-maf">Incluye bono MAF de {CurrencyFormat(version.financing_bonus)}.</span>
                                                        : null}
                                                    {version.smart_buy_bonus ?
                                                        <span className="bono-maf">Incluye financiamiento Plan Renueve {CurrencyFormat(version.smart_buy_bonus)}.</span>
                                                        : null}
                                                </div>
                                                <div className="btn outline-red small">PREAPROBADO</div>
                                            </div>
                                            :
                                            <>
                                                {isEvaluating ?
                                                    <>
                                                        <div className="evaluando-container">
                                                            <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/evaluating.svg`} />
                                                            <span>Estamos evaluando tu preaprobación</span>
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="fees-details">
                                                        <p>{financiado.number_fees} cuotas de {CurrencyFormat(financiado.fee_value)}</p>
                                                        <ul>
                                                            <li>+ Valor del pie: {CurrencyFormat(financiado.downpayment_amount)}</li>
                                                            <li>+ Cuota Final: {CurrencyFormat(financiado.future_value_guaranteed)}</li>
                                                        </ul>
                                                        <div className="details-container">
                                                            {version.financing_bonus ?
                                                                <span className="bono-maf">Incluye bono MAF de {CurrencyFormat(version.financing_bonus)}.</span>
                                                                : null}
                                                            {version.smart_buy_bonus ?
                                                                <span className="bono-maf">Incluye financiamiento Plan Renueve {CurrencyFormat(version.smart_buy_bonus)}.</span>
                                                                : null}
                                                        </div>
                                                        <div className="btn outline-black small evaluando-button">EN EVALUACION</div>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                }
                            </div>
                        }
                         */}
                    </div>
                ) : null}
                <div className={"item-box " + (ignoreFinanciado.value ? 'active' : '')} onClick={() => setIgnoreFinanciado(true)}>
                    <span>Contado</span>
                </div>

            </div>
            <ModalFinanciado isOpen={isOpen} simulateDataDefault={simulateData} onCloseModal={() => setIsOpen(false)} />
        </div>
    )
}

export default PaymentOptions;